import { createRouter, createWebHashHistory, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { businessRoutes, hasPermission } from './foundation/navigation'

const routes:RouteRecordRaw[]=[
  {path:'/login',component:()=>import('./views/LoginView.vue'),meta:{public:true}},
  {path:'/',component:()=>import('./views/DashboardView.vue'),meta:{title:'工作台'}},
  ...businessRoutes(),
  {path:'/profile',component:()=>import('./views/ProfileView.vue'),meta:{title:'个人资料'}},{path:'/system',component:()=>import('./views/SystemInfoView.vue'),meta:{title:'系统设置'}},
  {path:'/403',component:()=>import('./views/SystemStateView.vue'),meta:{public:true,title:'无权访问',state:'403'}},
  {path:'/500',component:()=>import('./views/SystemStateView.vue'),meta:{public:true,title:'服务异常',state:'500'}},
  {path:'/maintenance',component:()=>import('./views/SystemStateView.vue'),meta:{public:true,title:'服务维护',state:'maintenance'}},
  {path:'/network-error',component:()=>import('./views/SystemStateView.vue'),meta:{public:true,title:'网络异常',state:'network'}},
  {path:'/:pathMatch(.*)*',component:()=>import('./views/SystemStateView.vue'),meta:{public:true,title:'页面不存在',state:'404'}}
]
const prototypeMode=import.meta.env.VITE_ADMIN_MODE==='prototype'
const router=createRouter({
  history:prototypeMode?createWebHashHistory():createWebHistory(),
  routes,
  scrollBehavior(to,_from,saved){
    if(saved)return saved
    const position=Number(sessionStorage.getItem(`ff-route-scroll:${to.fullPath}`)||0)
    return {top:position,left:0}
  },
})
router.beforeEach(to=>{
  if(to.meta.public)return true
  if(!sessionStorage.getItem('ff_admin_token'))return{path:'/login',query:{redirect:to.fullPath}}
  let user:Record<string,any>={}
  try{user=JSON.parse(sessionStorage.getItem('ff_admin_user')||'{}')}catch{}
  if(!hasPermission(to.meta.permission,user))return{path:'/403',query:{from:to.fullPath}}
  return true
})
router.afterEach((_to,from)=>sessionStorage.setItem(`ff-route-scroll:${from.fullPath}`,String(window.scrollY)))
export default router
